<script lang="ts" setup>
const { user, admin, logout } = useUser()
</script>

<template>
  <div class="flex space-4 flex-col">
    <p class="capitalize font-bold">
      Hello {{ user?.name }}
    </p>
    <div class="flex">
      <div class="text-xs text-gray-500">
        {{ user?.email }}
      </div>
    </div>
    <hr class="my-4">
    <ul class="space-y-3">
      <li v-if="!admin">
        <NuxtLink
          to="/dashboard"
          class="hover:text-darkblue"
        >
          Dashboard
        </NuxtLink>
      </li>
      <li v-if="admin">
        <NuxtLink
          to="/admin"
          class="hover:text-darkblue"
        >
          Administration
        </NuxtLink>
      </li>
      <li>
        <button
          class="gap-x-3 flex items-center group/logout hover:text-darkblue"
          @click="logout"
        >
          <Icon
            name="ri:logout-box-r-line"
            class="group-hover/logout:text-yellow"
          />
          Logout
        </button>
      </li>
    </ul>
  </div>
</template>
